export default __webpack_public_path__ + "static/media/application-active.53386999.svg";